import React, { useEffect, useState } from 'react';
import { reduxForm, change, Field } from 'redux-form';
import { Button, Modal, Popover,  OverlayTrigger } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import i18next from 'i18next';
import {faQuestionCircle} from '@fortawesome/fontawesome-free-solid';
import FontAwesomeIcon from "@fortawesome/react-fontawesome";

import { SelectInput, SelectIconRenderer } from '../SelectInput';
import { components } from 'react-select';
import { TextInput } from '../TextInput';
import { PageLevelAccess } from '../PageLevelAccess';
import { FeatureAccess } from '../FeatureAccess';
import { DeviceDataOverrideService } from '../../services';

const ThresholdForm = ({ configurationData, initialize, backLinkWithParams, handleSubmit, deleteThresholdAction, form, dispatch }) => {
  const tagOptions = configurationData.availableTags.map((tag) => ({ value: tag.id, label: tag.name, tag: tag }));
  const fullThresholdEvaluationTypeOptions = configurationData.availableThresholdEvaluationTypes.map(thresholdEvaluationType => ({ value: thresholdEvaluationType.id, label: i18next.t(`threshold-evaluation-types.${thresholdEvaluationType.token}`), thresholdEvaluationType: thresholdEvaluationType }));
  const fullThresholdClassificationOptions = configurationData.availableThresholdClassifications.map(thresholdClassification => ({ value: thresholdClassification.id, label: i18next.t(`threshold-classifications.${thresholdClassification.token}`), thresholdClassification: thresholdClassification }));
  const deviceDataTypeOptions = configurationData.availableDeviceDataTypes.map(deviceDataType => ({ value: deviceDataType.id, label: `${i18next.t(`device-data-types.${deviceDataType.token}`)} : ${i18next.t(`device-data-types.description.${deviceDataType.token}`)}`, deviceDataType: deviceDataType }));
  const deviceDataClassificationOptions = configurationData.availableDeviceDataClassifications.map(deviceDataClassification => ({ value: deviceDataClassification.id, label: i18next.t(`device-data-classifications.${deviceDataClassification.token}`), deviceDataClassification: deviceDataClassification }));

  const filterEvaluationTypeOptions = (fullThresholdEvaluationTypeOptions, deviceDataValueType) => {
    return fullThresholdEvaluationTypeOptions.filter(option =>
      option.thresholdEvaluationType.valueType === deviceDataValueType.token
    );
  };

  const filterThresholdClassificationOptionsWithDDT = (fullThresholdClassificationOptions, deviceDataType) => {
    return fullThresholdClassificationOptions.filter(option =>
      option.thresholdClassification.deviceDataType.token === deviceDataType.token
    );
  };

  const filterThresholdClassificationOptionsWithDDC = (fullThresholdClassificationOptions, deviceDataClassification) => {
    return fullThresholdClassificationOptions.filter(option =>
      option.thresholdClassification.deviceDataType.deviceDataClassification?.token === deviceDataClassification.token
    );
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [thresholdEvaluationTypeOptions, setThresholdEvaluationTypeOptions] = useState(
    configurationData.threshold == null || (configurationData.threshold.deviceDataType == null && configurationData.threshold.deviceDataClassification == null) ? null : 
      configurationData.threshold.deviceDataType != null ? 
      filterEvaluationTypeOptions(fullThresholdEvaluationTypeOptions, configurationData.threshold.deviceDataType.deviceDataValueType) :
      filterEvaluationTypeOptions(fullThresholdEvaluationTypeOptions, configurationData.threshold.deviceDataClassification.deviceDataValueType)
  );
  const [thresholdClassificationOptions, setThresholdClassificationOptions] = useState(
    configurationData.threshold == null || (configurationData.threshold.deviceDataType == null && configurationData.threshold.deviceDataClassification == null) ? null : 
    configurationData.threshold.deviceDataType != null ? 
    filterThresholdClassificationOptionsWithDDT(fullThresholdClassificationOptions, configurationData.threshold.deviceDataType) :
    filterThresholdClassificationOptionsWithDDC(fullThresholdClassificationOptions, configurationData.threshold.deviceDataClassification)
  );
  const [thresholdEvaluationType, setThresholdEvaluationType] = useState(configurationData.threshold == null || configurationData.threshold.thresholdEvaluationType == null ? null : configurationData.threshold.thresholdEvaluationType);
  const [currentDeviceDataType, setCurrentDeviceDataType] = useState(configurationData.threshold == null || configurationData.threshold.deviceDataType == null ? null : configurationData.threshold.deviceDataType);
  const [currentDeviceDataClassification, setCurrentDeviceDataClassification] = useState(configurationData.threshold == null || configurationData.threshold.deviceDataClassification == null ? null : configurationData.threshold.deviceDataClassification);
  
  useEffect(() => {
    if (configurationData.threshold) {
      let thresholdEvaluationTypeValue = null;
      if (configurationData.threshold.displayableEvaluationNumericValue || configurationData.threshold.displayableEvaluationNumericValue == 0) {
        const deviceDataTypeToken = configurationData.threshold.deviceDataType?.token ?? configurationData.threshold.deviceDataClassification?.token;
        const fnToApply = DeviceDataOverrideService.getOverrideFunctionForDeviceTypeToken(deviceDataTypeToken);
        thresholdEvaluationTypeValue = fnToApply(configurationData.threshold.displayableEvaluationNumericValue);
      } else if (configurationData.threshold.displayableEvaluationStringValue) {
        thresholdEvaluationTypeValue = configurationData.threshold.displayableEvaluationStringValue;
      } else if (configurationData.threshold.displayableEvaluationBooleanValue === true || configurationData.threshold.displayableEvaluationBooleanValue === false)  {
        thresholdEvaluationTypeValue = {value: configurationData.threshold.displayableEvaluationBooleanValue, label: configurationData.threshold.displayableEvaluationBooleanValue ? 'True' : 'False'};
      }

      initialize({
        name: configurationData.threshold.name,
        description: configurationData.threshold.description,
        deviceDataType: configurationData.threshold.deviceDataType == null ? null : { value: configurationData.threshold.deviceDataType.id, label: `${i18next.t(`device-data-types.${configurationData.threshold.deviceDataType.token}`)} : ${i18next.t(`device-data-types.description.${configurationData.threshold.deviceDataType.token}`)}`, deviceDataType: configurationData.threshold.deviceDataType },
        deviceDataClassification: configurationData.threshold.deviceDataClassification == null ? null : { value: configurationData.threshold.deviceDataClassification.id, label: i18next.t(`device-data-classifications.${configurationData.threshold.deviceDataClassification.token}`), deviceDataClassification: configurationData.threshold.deviceDataClassification },
        thresholdEvaluationType: configurationData.threshold.thresholdEvaluationType == null ? null : { value: configurationData.threshold.thresholdEvaluationType.id, label: i18next.t(`threshold-evaluation-types.${configurationData.threshold.thresholdEvaluationType.token}`), thresholdEvaluationType: configurationData.threshold.thresholdEvaluationType },
        thresholdClassification: configurationData.threshold.thresholdClassification == null ? null : { value: configurationData.threshold.thresholdClassification.id, label: i18next.t(`threshold-classifications.${configurationData.threshold.thresholdClassification.token}`), thresholdClassification: configurationData.threshold.thresholdClassification },
        thresholdEvaluationTypeValue: thresholdEvaluationTypeValue,
        tags: configurationData.threshold.tags.map(tag => ({ value: tag.id, label: tag.name, tag: tag }))
      });
    } else {
      initialize({
        name: null,
        description: null,
        deviceDataType: null,
        deviceDataClassification: null,
        thresholdEvaluationType: null,
        thresholdClassification: null,
        thresholdEvaluationTypeValue: null,
        tags: null
      });
    }
  }, []);

  const updateDeviceDataTypeValue = (newValue) => {
    if (thresholdEvaluationType && thresholdEvaluationType.valueType != newValue.deviceDataType?.deviceDataValueType?.token) {
      setThresholdEvaluationType(null);
      dispatch(change('ThresholdForm', 'thresholdEvaluationType', null));
      dispatch(change('ThresholdForm', 'thresholdEvaluationTypeValue', ''));
    }

    setCurrentDeviceDataType(newValue.deviceDataType);

    dispatch(change("ThresholdForm", "thresholdClassification", null));
    dispatch(change("ThresholdForm", "thresholdClassificationValue", ""));

    if (newValue.deviceDataType) {
      setThresholdEvaluationTypeOptions(filterEvaluationTypeOptions(fullThresholdEvaluationTypeOptions, newValue.deviceDataType.deviceDataValueType));
      setThresholdClassificationOptions(filterThresholdClassificationOptionsWithDDT(fullThresholdClassificationOptions, newValue.deviceDataType));
    } else {
      setThresholdEvaluationTypeOptions(null);
      setThresholdClassificationOptions(null);
    }
  }

  const updateDeviceDataClassificationValue = (newValue) => {
    if (thresholdEvaluationType && thresholdEvaluationType.valueType != newValue.deviceDataClassification?.deviceDataValueType?.token) {
      setThresholdEvaluationType(null);
      dispatch(change('ThresholdForm', 'thresholdEvaluationType', null));
      dispatch(change('ThresholdForm', 'thresholdEvaluationTypeValue', null));
    }

    setCurrentDeviceDataClassification(newValue.deviceDataClassification);

    dispatch(change("ThresholdForm", "thresholdClassification", null));
    dispatch(change("ThresholdForm", "thresholdClassificationValue", ""));

    if (newValue.deviceDataClassification) {
      setThresholdEvaluationTypeOptions(filterEvaluationTypeOptions(fullThresholdEvaluationTypeOptions, newValue.deviceDataClassification.deviceDataValueType));
      setThresholdClassificationOptions(filterThresholdClassificationOptionsWithDDC(fullThresholdClassificationOptions, newValue.deviceDataClassification));
    } else {
      setThresholdEvaluationTypeOptions(null);
      setThresholdClassificationOptions(null);
    }
  }

  const toggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  return (
    <div className="login-form">
      <form onSubmit={handleSubmit}>
        <div>
          <Field name="name" type="text" component={TextInput} label={i18next.t('form-labels.name')} />
        </div>
        
        <div>
          <Field name="description" type="text" component={TextInput} label={i18next.t('form-labels.description')} />
        </div>

        <div className='row'>
          <FeatureAccess feature='ENABLE_THRESHOLD_CLASSIFICATION_MATCHING'>
            <div className='col-sm-12' style={{paddingBottom: 5}}>
              Select from one of the following. &nbsp;
              <OverlayTrigger trigger="click" rootClose placement="right" overlay={ <MeasurementHelp /> }>
                <a className="map-filter-button status-filter"><FontAwesomeIcon icon={faQuestionCircle} size='sm' /></a>
              </OverlayTrigger>
            </div>
          </FeatureAccess>

          <div className="form-group col-sm-6">
            <label>{i18next.t('form-labels.measurement')}</label>
            <Field
              name="deviceDataType"
              component={SelectInput}
              isClearable={true}
              searchable={false}
              options={deviceDataTypeOptions}
              onChange={updateDeviceDataTypeValue}
              components={{ SingleValue : SelectIconSingleValue, Option : SelectIconOption }}
              isDisabled={currentDeviceDataClassification}
            />
          </div>
          
          <FeatureAccess feature='ENABLE_THRESHOLD_CLASSIFICATION_MATCHING'>
            <div className="form-group col-sm-6">
              <label>Measurement Type</label>
              <Field
                name="deviceDataClassification"
                component={SelectInput}
                isClearable={true}
                searchable={false}
                options={deviceDataClassificationOptions}
                onChange={updateDeviceDataClassificationValue}
                components={{ SingleValue : SelectIconSingleValue, Option : SelectIconOption }}
                isDisabled={currentDeviceDataType}
              />
            </div>
          </FeatureAccess>
        </div>

        {
          thresholdEvaluationTypeOptions &&
          <div className="form-group">
            <label>{i18next.t('form-labels.comparison')}</label>
            <Field
              name="thresholdEvaluationType"
              component={SelectInput}
              isClearable={false}
              options={thresholdEvaluationTypeOptions}
              onChange={(newValue) => { setThresholdEvaluationType(newValue.thresholdEvaluationType); }}
            />
          </div>
        }

        <ValueTypeField deviceDataType={currentDeviceDataType} deviceDataClassification={currentDeviceDataClassification} valueType={thresholdEvaluationType} />

        {
          thresholdClassificationOptions &&
          <div className="form-group">
            <label>{i18next.t('form-labels.classification')}</label>
            <Field
              name="thresholdClassification"
              component={SelectInput}
              clearable={false}
              searchable={false}
              options={thresholdClassificationOptions}
              components={{ SingleValue : SelectIconSingleValue, Option : SelectIconOption }}
            />
          </div>
        }

        <div className="form-group">
          <label>{i18next.t('form-labels.apply-to-tags')}</label>
          <Field name="tags" clearable={false} options={tagOptions} component={SelectInput} isMulti />
        </div>

        <hr />

        <ButtonSection 
          backLinkWithParams={backLinkWithParams} 
          alerts={configurationData.alerts} 
          canDelete={deleteThresholdAction != null} 
          doDelete={toggleDeleteModal}
        />

        <DeleteModal 
          showDeleteModal={showDeleteModal} 
          formName={form.ThresholdForm.values ? form.ThresholdForm.values.name : ''}
          isAssociated={configurationData.isAssociated}
          onHide={toggleDeleteModal} 
          onDelete={() => { deleteThresholdAction(configurationData.threshold.id); }}
        />
      </form>
    </div>
  );
}

const MeasurementHelp = ({...props}) => {
  const {...rest} = props;
  return (
  <Popover id="measurement-help-popover" {...rest} >
    <div style={{padding: '20px'}}>
      A measurement selection will apply this threshold to a specific 
      measurement or a measurement type selection will apply this threshold to any measurement type. 
      <br/>
      <br/>
      Applying a threshold to a specific measurement will match exactly one measurement of a device or asset. 
      For example a device may have measurements named "temperature" and "probe temperature", when a specific 
      measurement is selected for the threshold then the threshold will apply to only the "tempeture" measurement 
      or the "probe tempature" measurement but not both. Applying a threshold to a measurement type will match 
      any measurement of a device or asset that is of the measurement type selected. For example if a device has 
      two temperature type measurements named "temperature" and "probe temperature", when a measurement type is 
      select for the threshold then the threshold will apply to both the "tempeture" measurement and the "probe 
      tempature" measurements.
    </div>
  </Popover>
  )
};

const ButtonSection = ({ backLinkWithParams, alerts, canDelete, doDelete }) => (
    <ul className="list-inline clearfix">
      <li className="pull-left">
        <button type="submit" className="btn btn-primary">{i18next.t('form-labels.save')}</button> <Link to={ backLinkWithParams ? backLinkWithParams.link : "/config/thresholds"}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link>
      </li>
      { 
        canDelete && alerts && alerts.length == 0 &&
        <PageLevelAccess to='/config/thresholds/edit/:thresholdId#delete'>
          <li className="pull-right"><a className="btn btn-danger" onClick={doDelete}>{i18next.t('delete')}</a></li>
        </PageLevelAccess>
      }
      { 
        alerts && alerts.length > 0 && 
        <li className="pull-right"> <p>{i18next.t('pages.thresholds.associated-with-alerts', {count: alerts.length})}</p> </li>
      }
    </ul>
);

const DeleteModal = ({ showDeleteModal, formName, isAssociated, onHide, onDelete }) => ( showDeleteModal && 
    <Modal show={showDeleteModal} onHide={onHide}>
        <Modal.Header closeButton>
        <Modal.Title>{i18next.t('pages.thresholds.delete-threshold', {name: formName})}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>{i18next.t('messages.are-you-sure-delete')}</p> <br/>
            { isAssociated && isAssociated["ALERT_CONFIG_ACTION"] ? <p>{i18next.t('messages.threshold-associated-with-active-config')}</p> : null }
            { isAssociated && isAssociated["CHECKLIST_ITEM_CONFIG"] ? <p key={"CHECKLIST_ITEM_CONFIG"}>{i18next.t('messages.threshold-associated-with-active-checklist')}</p> : null }
        </Modal.Body>
        <Modal.Footer>
            <a className="btn btn-danger" onClick={onDelete}>{i18next.t('delete')}</a>
            <Button onClick={onHide}>{i18next.t('form-labels.cancel')}</Button>
        </Modal.Footer>
    </Modal>
);

const SelectIconSingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      {SelectIconRenderer(props.selectProps.value)}
    </components.SingleValue>
);

const SelectIconOption = (props) => (
    <components.Option {...props}>
      {SelectIconRenderer(props.data)}
    </components.Option>
);

const ValueTypeField = ({ valueType, deviceDataType, deviceDataClassification }) => {
  if (valueType == null) {
    return null;
  }

  if (valueType.valueType === 'numeric') {    
    return (
      <div style={{paddingBottom: 5}}>
        <Field
          name="thresholdEvaluationTypeValue"
          type="number"
          component={TextInput}
          label={i18next.t([`device-data-display-types.${DeviceDataOverrideService.getOverrideForDisplayToken(deviceDataType?.token)}`, `device-data-display-types.${DeviceDataOverrideService.getOverrideForDisplayToken(deviceDataClassification?.token)}`, 'form-labels.numeric-value'])}
        />
      </div>
    );
  } else if (valueType.valueType === 'string') {
    return (
      <div style={{paddingBottom: 5}}>
        <Field
          name="thresholdEvaluationTypeValue"
          type="text"
          component={TextInput}
          label={i18next.t([`device-data-display-types.${deviceDataType?.token}`, `device-data-classifications.${deviceDataClassification?.token}`, 'form-labels.string-value'])}
        />
      </div>
    );
  } else if (valueType.valueType === 'boolean') {
    return (
      <div style={{paddingBottom: 10}}>
        <Field
          name="thresholdEvaluationTypeValue"
          options={[{ value: true, label: 'True' }, { value: false, label: 'False' }]}
          component={SelectInput}
          label={i18next.t([`device-data-display-types.${deviceDataType?.token}`, `device-data-classifications.${deviceDataClassification?.token}`, 'form-labels.boolean-value'])}
        />
      </div>
    );
  }

  return null;
}

const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-threshold-name');
  }

  if (!values.description) {
    errors.description = i18next.t('messages.please-enter-threshold-description');
  }

  if (!values.deviceDataType && !values.deviceDataClassification) {
    errors.deviceDataType = i18next.t('messages.please-select-measurement');
  }

  if (!values.thresholdEvaluationType) {
    errors.thresholdEvaluationType = i18next.t('messages.please-select-comparison');
  }

  if (!values.thresholdClassification) {
    errors.thresholdClassification = i18next.t('messages.please-select-classification');
  }

  if (!values.tags || values.tags.length === 0) {
    errors.tags = i18next.t('messages.please-select-at-least-one-tag');
  }

  if (!values.thresholdEvaluationTypeValue) {
    errors.thresholdEvaluationTypeValue = i18next.t('messages.please-select-threshold-evaluation-type-value');
  }

  return errors
}

export default reduxForm({ form: "ThresholdForm", validate })(connect((state) => ({ form: state.form }))(ThresholdForm));
